import {
    GET_APPROVAL_HIERARCHY_BY_SUPER_REGION_ID,
    SET_APPROVAL_HIERARCHY_BY_SUPER_REGION_ID,
    GET_SAVE_APPROVAL_HIERARCHY,
    SET_SAVE_APPROVAL_HIERARCHY,
    GET_VALIDATE_TITLE,
    SET_VALIDATE_TITLE,
    GET_SAVE_TITLE,
    SET_SAVE_TITLE,
    SET_APPROVAL_HIERARCHY_TABLE_EXCEL,
    GET_APPROVAL_HIERARCHY_TABLE_EXCEL,
    GET_IS_VALID_SKIP_APPROVAL,
    SET_IS_VALID_SKIP_APPROVAL,
    GET_ADDITIONAL_APPROVAL_BY_SUPER_REGION_ID,
    SET_ADDITIONAL_APPROVAL_BY_SUPER_REGION_ID
} from "./ApprovalHierarhyType"

const getApprovalHierarchyBySuperRegion = (payload: any) => ({
    type: GET_APPROVAL_HIERARCHY_BY_SUPER_REGION_ID,
    payload
})

const setApprovalHierarchyBySuperRegion = (approvalHierarchyBySuperRegion: any) => ({
    type: SET_APPROVAL_HIERARCHY_BY_SUPER_REGION_ID,
    approvalHierarchyBySuperRegion: approvalHierarchyBySuperRegion
})

const getAdditionalApprovalBySuperRegion = (payload: any) => ({
    type: GET_ADDITIONAL_APPROVAL_BY_SUPER_REGION_ID,
    payload
})

const setAdditionalApprovalBySuperRegion = (additionalApprovalBySuperRegion: any) => ({
    type: SET_ADDITIONAL_APPROVAL_BY_SUPER_REGION_ID,
    additionalApprovalBySuperRegion: additionalApprovalBySuperRegion
})

const getSaveApprovalHierarchy = (payload: any, actionType: any) => ({
    type: GET_SAVE_APPROVAL_HIERARCHY,
    payload, actionType
})

const setSaveApprovalHierarchy = (isApprovalHierarchySaved: any) => ({
    type: SET_SAVE_APPROVAL_HIERARCHY,
    isApprovalHierarchySaved: isApprovalHierarchySaved
})

const getValidateTitle = (payload: any) => ({
    type: GET_VALIDATE_TITLE,
    payload
})

const setValidateTitle = (isValidTitle: any) => ({
    type: SET_VALIDATE_TITLE,
    isValidTitle: isValidTitle
})

const getSaveTitle = (payload: any) => ({
    type: GET_SAVE_TITLE,
    payload
})

const setSaveTitle = (isTitleSaved: any) => ({
    type: SET_SAVE_TITLE,
    isTitleSaved: isTitleSaved
})

const getApprovalHierarchyTableExcel = (payload: any, isAdditionalApprover: boolean = false) => ({
    type: GET_APPROVAL_HIERARCHY_TABLE_EXCEL,
    payload,
    isAdditionalApprover
})

const setApprovalHierarchyTableExcel = (approvalHierarchyTableExcel: any) => ({
    type: SET_APPROVAL_HIERARCHY_TABLE_EXCEL,
    approvalHierarchyTableExcel: approvalHierarchyTableExcel
})

const getIsValidSkipApproval = (payload: any) => ({
    type: GET_IS_VALID_SKIP_APPROVAL,
    payload
})

const setIsValidSkipApproval = (isValidSkipApproval: any) => ({
    type: SET_IS_VALID_SKIP_APPROVAL,
    isValidSkipApproval: isValidSkipApproval
})

export {
    getApprovalHierarchyBySuperRegion,
    setApprovalHierarchyBySuperRegion,
    getAdditionalApprovalBySuperRegion,
    setAdditionalApprovalBySuperRegion,
    getSaveApprovalHierarchy,
    setSaveApprovalHierarchy,
    getValidateTitle,
    setValidateTitle,
    getSaveTitle,
    setSaveTitle,
    getApprovalHierarchyTableExcel,
    setApprovalHierarchyTableExcel,
    getIsValidSkipApproval,
    setIsValidSkipApproval
}